import { getDataFromServer, putDataToServer } from '../../../util';
import { SCENARIO_RI_FAILED } from '../../../../pages/trm/configureInstanceDashboard/constants';

class RiskIndicatorModule {
  constructor(baseURL, httpHeaders) {
    this.baseURL = baseURL;
    this.httpHeaders = httpHeaders;
  }

  fetchRIByScenarioId = async (payload) => {
    const { scenarioId = '', typologyId = '' } = payload;
    const url = `${this.baseURL}/scenarios/${scenarioId}/typologies/${typologyId}/riskIndicators`;
    return await getDataFromServer(url, this.httpHeaders);
  };

  updateRIByScenarioId = async (payload) => {
    const { scenarioId, data } = payload;
    const url = `${this.baseURL}/scenarios/${scenarioId}/typologies/riskIndicators`;
    const response = await putDataToServer(url, this.httpHeaders, {}, data);

    if (response.status !== 200 && response.status !== 201) {
      throw new Error(response.data.message ?? SCENARIO_RI_FAILED);
    } else {
      return response.data;
    }
  };
}

export default RiskIndicatorModule;
